<template>
  <div class="md-card dash_card md-card-tabs">
    <div>
      <i class="point margin_r"></i>
      {{$t('dashboardLeft.Live.Data')}}
    </div>
    <h4 class="md-card-header font_bold">{{title}}</h4>
    <div class="md-card-content">
      <div class="flex flex_between" v-for="item in infoData" :key="item.id">
        <p class="label_p text_left">{{ $t(item.$key) }}</p>
        <p class="flex_1 text_center" v-if="showEur">{{item.count}}</p>
        <p class="flex_1 text_right">
          {{millionFormat(item.amount) }}
          <i
            v-if="isMillion(item.amount)"
          >Mio.</i>
          &nbsp;
          <span v-if="dashboardFilter.type==='seller'">{{dashboardFilter.currency}}</span>
          <span v-else>{{dashboardFilter.accountCurrency}}</span>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import {mapGetters} from "vuex";

export default {
  inject: {
    theme: {
      //函数式组件取值不一样
      default: () => ({})
    }
  },
  props: {
    infoData: [Object, Array],
    title: String,
    showEur: { type: Boolean, default: true }
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({ dashboardFilter: "dashboardFilter" })
  }
};
</script>